import { useCallback, useState } from 'react';
import { useGetArtistProfileQuery } from '../../../../../redux/api/fymAPI';
import { useSMLRouter } from '../../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../../routing/sml/SMLRoutes';
import { useProfileMake } from '../useProfileMake';
import { profileToolParams } from '../profileRoute';

/**
 * The Kit tab shortcut of the Profile (design c3, spec D4): `from-release` with the release (and
 * the kit file of the Spotify header slot), "Open Profile", and the profile answer for "In your
 * profile". Never an automatic write: only a click changes the Profile.
 */
export function useKitProfileShortcut(accountId: number) {
  const router = useSMLRouter();
  const { data } = useGetArtistProfileQuery({ accountId });
  const make = useProfileMake(accountId);
  const [doneKey, setDoneKey] = useState<string | null>(null);

  const use = useCallback(
    (catalogItemUuid: string, kitAssetUuid?: string) => {
      setDoneKey(null);
      make
        .fromRelease(catalogItemUuid, kitAssetUuid)
        .then((done) => setDoneKey(done ? (kitAssetUuid ?? catalogItemUuid) : null))
        .catch(console.error);
    },
    [make]
  );
  const openProfile = useCallback(
    (header = false) => router.push(SMLRoutes.promoteProfile, header ? profileToolParams('spotifyHeader') : undefined),
    [router]
  );

  return { profile: data, use, openProfile, doneKey, isBusy: make.isBusy, feedback: make.feedback };
}
